//@flow
import React from 'react';
import ModalActions from '../../Actions/modal';
import Constants from '../../constants';

function _openModal() {
  ModalActions.openModal(Constants.MSRP_POP_MODAL);
}

export default function MsrpLearnMoreLink() {
  return (
    <span onClick={_openModal} className="learn-more link-small">Learn more</span>
  );
}
